import { ConfirmDialogHost } from '@/shared/components/ConfirmDialogHost';
import { DialogHost } from '@/shared/components/DialogHost';
import { ShortcutHost } from '@/shared/components/ShortcutHost';
import { Toaster } from '@/shared/components/ui/sonner';
import { Trans } from '@lingui/react/macro';
import type { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';

/**
 * Typed router context. Carries the TanStack Query client so `beforeLoad`
 * permission guards can resolve the caller's permissions
 * (`ensureQueryData`) before a route loads, without a second cache.
 */
export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  // Bare shell: the full-screen auth pages (`/login`, `/auth-action`) render
  // without chrome; the standard authenticated app chrome lives in the
  // `_authenticated/_app` layout instead. The global toast surface is mounted here so any page can
  // fire notifications.
  component: () => (
    <>
      <Outlet />
      <DialogHost />
      <ConfirmDialogHost />
      <ShortcutHost />
      <Toaster />
    </>
  ),
  notFoundComponent: () => (
    <div className="p-6 text-muted-foreground">
      <Trans>Page not found.</Trans>
    </div>
  ),
});
